import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { onboardingSettingsAsMember } from "./onboardingSettingsAsMemberQueryKeys";

export function useQueryOnboardingSettingsAsMember({
  api,
  memberId,
}: {
  api: ApiType;
  memberId: string | undefined;
}) {
  return useQuery({
    queryKey: onboardingSettingsAsMember.all(),
    queryFn: async () =>
      (await api.onboardingSettingsAsMemberApi.getAll()).data,
    enabled: !!memberId,
  });
}
